
import './components/application_menu';
import './components/handle_session';
import './components/alert';
import './components/bs_collapse';
import './components/accordion_flush';
import './components/modal';
import './components/update_text_on_trix_change';
import './components/integrations';
import './components/turbo_frame';
import './components/turbo_stream_actions';
import './hacks/modal-stack';
import './hacks/select2';
import './channels';
import Mask from './utilities/masks';
import Filter from './components/filter';
import Tour from './components/tour';
import AjaxLoader from './utilities/ajax-loader';
import Gtm from '../lib/gtm';

document.addEventListener("turbo:load", (event) => {
  Mask.define();
  Filter.init();
  Tour.init();

  if (Traus.env.prod === 'true' || Object.keys(document.querySelector('html').dataset).includes('tagAssistantPresent')) {
    Gtm.load();
    Gtm.trackGoogleAnalytics(event);
  }

  // submit form
  $(document).on('click', 'button[data-submit-form], a[data-submit-form]', (ev) => {
    AjaxLoader.show();
    let form = document.querySelector('form[data-submit-form]'),
      action = form.getAttribute('action'),
      fragment = ev.currentTarget.dataset.fragment;

    !!fragment && form.setAttribute('action', `${action.replaceAll(/\#.*$/ig, '')}#${fragment}`);
    // Submit only the resolved form. Lazy turbo-frames (batch stats reports) inject their own
    // form[data-submit-form], and submitting every match navigated to the last one instead.
    $(form).trigger('submit');
  });

  $(document).on('click', '[data-disable-on-click]', function(ev) {
    this.setAttribute('disabled', '');
  });

  $.each(['href', 'data-confirm', 'data-method'], function() { return $('a[disabled]').removeAttr(this); });

  document.addEventListener('turbo:click', function() {
    !!window.fcWidget && window.fcWidget.destroy();
  });
});